// extracted by mini-css-extract-plugin
export default {"root":"JsonDebug_root__dkJze"};